'use client';
import { useAboutDataContext } from '@/providers/AboutDataProvider';
import { DynamicVideoEmbed } from '@/components/features/VideoTourSection/DynamicVideoEmbed/DynamicVideoEmbed';
import { API_STATIC_FILES } from '@/utils/constants';
import s from './VideoTourSection.module.scss';

export const VideoTourSection = ({ src }: { src?: string }) => {
  const { aboutData } = useAboutDataContext();

  const url = src
    ? `${API_STATIC_FILES}${src}`
    : aboutData?.video_clinic ? `${API_STATIC_FILES}${aboutData?.video_clinic}` : null;

  if (!url) return null;

  return (
    <section className={s.videoTour}>
      <div className="custom-container">
        <h2 className={s.subTitle}>Видеотур </h2>
        <DynamicVideoEmbed src={url} />
      </div>
    </section>
  );
};